<template>
  <!--
      	作者：luoyiming
      	时间：2019-06-04
      	描述：插件中心-优惠券-优惠券列表-添加优惠券
      -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">

      <div class="common-form">基本信息</div>
      <el-form-item label="卡包类型">
        <el-radio-group v-model="form.coupon_type">
          <el-radio label="10">满减券</el-radio>
          <el-radio label="20">折扣券</el-radio>
          <!-- <el-radio label="30">礼品卡</el-radio> -->
          <!-- <el-radio label="40">充值卡</el-radio> -->
          <el-radio label="100">新人券</el-radio>
          <el-radio label="110">商品券</el-radio>
          <el-radio label="120">客户券</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="卡包名称" prop="name" :rules="[{ required: true, message: ' ' }]">
        <el-input v-model="form.name" placeholder="请输入卡包名称"></el-input>
        <div class="tips">例如：满100减10</div>
      </el-form-item>

      <el-form-item label="卡包背景图">
        <div v-if="form.bgImage" class="default-image-box" @click="bgUpload('bg')">
          <div class="image-box">
            <img :src="form.bgImage.file_path" alt="bgImage">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteBgImg('bg')" >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="bgUpload('bg')"><i class="el-icon-plus"></i></div>
        </div>
        <div class="lh18 mt10 gray9">
          <p>推荐尺寸：显示图片长宽为 1000×600</p>
        </div>
      </el-form-item>
      <el-form-item label="分享封面">
        <div v-if="form.share_image" class="default-image-box" @click="bgUpload('share')">
          <div class="image-box">
            <img :src="form.share_image.file_path" alt="share_image">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteBgImg('share')" >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="bgUpload('share')"><i class="el-icon-plus"></i></div>
        </div>
        <div class="lh18 mt10 gray9">
          <p>尺寸：显示图片长宽为 500×400</p>
        </div>
      </el-form-item>
      <el-form-item label="兑换背景" v-if="form.coupon_type==30">
        <div v-if="form.exchange_bg" class="default-image-box" @click="bgUpload('exchange_bg')">
          <div class="image-box">
            <img :src="form.exchange_bg" alt="exchange_bg">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteBgImg('exchange_bg')" >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="bgUpload('exchange_bg')"><i class="el-icon-plus"></i></div>
        </div>
        <div class="lh18 mt10 gray9">
          <p>建议尺寸：750*1334</p>
        </div>
      </el-form-item>

      <div  v-if="form.coupon_type==30 || form.coupon_type==40">
        <el-form-item label="限制兑换时间">
          <el-radio-group v-model="form.exchange_type">
            <el-radio :label="0">不限制</el-radio>
            <el-radio :label="10">限制</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效兑换时间" v-if="form.exchange_type==10">
          <el-date-picker
            v-model="form.exchange_time"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="兑换开始时间"
            end-placeholder="兑换结束时间"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :picker-options="pickerOptions"
            >
          </el-date-picker>
          </el-form-item>
      </div>

      <el-form-item label="选择归属分销商" v-if="form.coupon_type == 30">
          <div class="d-s-s d-c">
            <el-button @click="openGetuser" icon="el-icon-plus">选择分销商</el-button>
            <ul class="d-s-s select-user"  v-if="referee">
              <li class="mr10 d-c-c d-c p-10-0" >
                  <img :src="referee.avatarUrl" class="radius" width="30" height="30" />
                  <p class="lh18 ww100 text-ellipsis">{{referee.nickName}}</p>
              </li>
              <li class="mr10 d-c-c d-c p-10-0" @click="deleteReferee">
                  删除
              </li>
            </ul>
          </div>
        </el-form-item>

      <el-form-item label="卡包颜色">
        <el-radio-group v-model="form.color">
          <el-radio label="10">蓝色</el-radio>
          <el-radio label="20">红色</el-radio>
          <el-radio label="30">紫色</el-radio>
          <el-radio label="40">黄色</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="到期类型">
        <el-radio-group v-model="form.expire_type">
          <el-radio label="10">领取后生效</el-radio>
          <el-radio label="20">固定时间</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="Number(form.expire_type) === 10">
        <el-form-item label="有效天数">
          <el-input v-model="form.expire_day" placeholder="请输入有效天数" type="number"></el-input>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="有效时间">
          <el-date-picker v-model="form.active_time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
      </div>


      <el-form-item label="是否开启注册即送券" v-if='Number(form.coupon_type) === 100'>
        <el-radio-group v-model="form.is_send_coupon">
          <el-radio :label="0">不开启</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>




      <el-form-item label="选择商品" v-if='Number(form.coupon_type) === 110'>
        <el-button icon="el-icon-plus" @click="changeProduct(form.applicable_products)">选择商品</el-button>
        <el-table size="small" :data="form.applicable_products"   border style="width: 100%" v-loading="loading">
          <el-table-column prop="product_name" label="商品"></el-table-column>

          <el-table-column prop="product_price" label="单价">
            <template slot-scope="scope">
            
           {{ scope.row.product_price }}
            </template>

          </el-table-column>
          

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="del(scope.$index)" size="mini">删除</el-button>
            </template>
          </el-table-column>
        </el-table>  

        <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="islist" @closeDialog="closeDialogFunc"></Product>

      </el-form-item>

      <el-form-item label="选择客户" v-if='Number(form.coupon_type) === 120'>
  
          <div class="d-s-s d-c">
            <el-button @click="openGetuser" icon="el-icon-plus">选择会员</el-button>
            <ul class="d-s-s select-user">
              <li class="mr10 d-c-c d-c p-10-0" v-for="(item,index) in select_list" :key="index"
              @click="delUser(index)">
                  <img :src="item.avatarUrl" class="radius" width="30" height="30" />
                  <p class="lh18 ww100 text-ellipsis">{{item.nickName}}</p>
              </li>
            </ul>
            <div>点击头像可删除</div>
          </div>
    
      </el-form-item>



      <!--添加商品-->
      <Pickup :form="form" v-if="Number(form.coupon_type) === 30"></Pickup>
      <Coupon :form="form" v-else-if="Number(form.coupon_type) != 40"></Coupon>

      <!-- 充值卡专有属性 -->
      <span v-if="Number(form.coupon_type)  === 40">
        <div >
        <el-form-item label="充值卡激活赠送卡余额">
          <el-input v-model="form.price" placeholder="请输入充值卡激活赠送卡余额" type="number"></el-input>
          </el-form-item>
        </div>

        <div >
          <el-form-item label="充值卡激活费用">
            <el-input v-model="form.nprice" placeholder="请输入充值卡激活费用" type="number"></el-input>
          </el-form-item>
        </div>
      </span>
    

      <!-- 添加门店 -->
      <!-- <el-form-item label="选择门店" v-if="Number(form.coupon_type) === 40"
      prop="store_id"
      >
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">选择门店</el-button>
          <div v-if="form.store_id!=''" class="img">
        
            <div>你选择的门店：{{ store.store_name }}</div>
          </div>
        </el-row>
        <el-button @click="remove" v-if="form.store_id!=''">移除门店</el-button>

        <div>设置门店后，只能在该门店使用</div>
      </el-form-item> -->

      
      <el-form-item label="使用说明" v-if="form.coupon_type!=40 ">
        <div class="edit_container">
          <Uediter :text="form.content" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc"></Uediter>
        </div>
      </el-form-item>
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="info" size="small" @click="cancelFunc" :loading="loading">取消</el-button>
        <el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button>
       </div>
    </el-form>
    <!--选择用户-->
    <!-- <GetUser :is_open="open_getuser"  @close="closeGetuserFunc"></GetUser> -->

    <GetUser :is_open="open_getusers" @close="closeGetuserFunc"></GetUser>

    <!-- 图片组件 -->
    <Upload v-if="isBgUpload" :config="{ total: 9 }" :isupload="isBgUpload" @returnImgs="returnBgImgFunc">上传图片</Upload>
    <Store  :is_open="is_open_store" @closex="closeStore" :multi="false"></Store>

 </div>
</template>

<script>
import CouponApi from '@/api/coupon.js';
import Coupon from './part/Coupon'
import Pickup from './part/Pickup'
import Upload from "@/components/file/Upload"
import Uediter from '@/components/UE.vue'
import GetUser from '@/components/user/GetReferee.vue';
import Store from '@/components/store/Store.vue';
import Product from '@/components/product/Product';
import {mergeTable} from '@/utils/table.js'
export default {
  components: {
    GetUser,
    Coupon,
    Pickup,
    Upload,
    Uediter,
    Store,
    Product
  },
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        color: '10',
        coupon_type: '10',
        expire_type: '10',
        exchange_type: 0,
        exchange_time:'',
        sort: 1,
        active_time: '',
        /*商品源数据*/
        tableData: [],
        // 发放总数
        total_num: -1,
        /*商品列表*/
        product_list: [],
        // 优惠券背景图
        bg_image: 0,
        bgImage: null,
        // 优惠券分享图片
        share_image: 0,
        shareImage: null,
        exchange_bg: '',
        // 优惠券使用说明
        content: '',
        usage_count: 1,

        store_id:0,
        price:0,
        nprice:0,
        is_send_coupon:0,
        applicable_products_ids:[],
        applicable_products:[]
      },
      store:{},
      is_open_store:false,
       /*获取用户是否显示*/
      open_getuser: false,
       /*选择的用户列表*/
      referee:'',
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      // 背景图上传开关
      isBgUpload: false,
      bg_type:'',
      /*富文本框配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },


      isproduct: false,
      /*产品去重*/
      excludeIds: [],
      islist:true,

     /*获取用户是否显示*/
     open_getusers: false,
      /*选择的用户列表*/
      select_list:[],
    };
  },
  created() {},

  methods: {


    del(ind){
      this.form.applicable_products.splice(ind,1);
 
    },
    /*关闭弹窗*/
    closeDialogFunc(e) {
    
      let self = this;
      self.isproduct = false;
      if (e.type === 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            product_name: item.product_name,
            product_id: item.product_id,
            product_sku_id: item.product_sku_id,
            product_price: item.product_price,
            product_image: item.product_image,
            unit: item.unit,
            spec_value:item.spec_value,
            status:0,//0 未入库 1  已入库
  
            file_path:item.image.file_path,
            rk:item.warehouse_management,
            category_name:item.category_name,
          };
          arr.push(obj)
        }
        self.form.applicable_products = self.form.applicable_products.concat(arr);
        self.form.applicable_products = mergeTable(this.form.applicable_products);

      
      }
    },
    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_sku_id);
      });
      this.excludeIds = arr;
      this.isproduct = true;
    },



    remove(){
      this.form.store_id = 0;
    },
    closeStore(e){
      console.log("选择的门店",e)
      var parmas = e.params
      this.form.store_id = parmas.store_id;
      this.store = parmas
    },
    addClick(){
      this.is_open_store = true;
      console.log( this.is_open_store);
    },
    // 删除用户
    deleteReferee(){
      this.referee = '';
      this.form.user_referee_id = 0;
    },
    //  /*打开获取用户*/
    openGetuser() {
      this.open_getusers = true;
    },
    
    /*关闭获取用户*/
    closeGetuserFunc(e) {
      if (e.type != 'error') {
        let newParams = e.params.filter(param => !this.select_list.some(item => parseInt(item.user_id) === parseInt(param.user_id)));
        this.select_list=this.select_list.concat(newParams);
      }
      this.open_getusers = false;
    },
    delUser(index){
      this.select_list.splice(index,1)
    },


    // /*关闭获取用户*/
    // closeGetuserFunc(e) {
    //   if (e.type != 'error') {
    //     this.referee=e.params[0];
    //      this.form.user_referee_id = e.params[0].user_id;
    //   }
    //   this.open_getuser = false;
    // },
    /*添加用户*/
    onSubmit() {
      let self = this;
      let form = self.form;
      if (Number(form.coupon_type) === 30) {
        form.product_list = self.tableFormet(self.form.tableData);
      }
      if (Number(form.coupon_type) === 110) {
        var applicable_products_ids =[];
        for(var i=0;i<self.form.applicable_products.length;i++){
          applicable_products_ids.push(self.form.applicable_products[i].product_id);
          }
          self.form.applicable_products_ids = applicable_products_ids
      }

      /*如果是指定用户*/
      if (Number(form.coupon_type) === 120) {
        let applicable_user_ids=[];
        let applicable_users = [];
        self.select_list.forEach((item)=>{
          applicable_user_ids.push(item.user_id);
          applicable_users.push({
            "user_id":item.user_id,
            "nickName":item.nickName,
            "mobile":item.mobile,
            "avatarUrl":item.avatarUrl,
          })
        })
        form.applicable_user_ids= applicable_user_ids;
        form.applicable_users = self.select_list;
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CouponApi.addCoupon(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，添加成功',
                type: 'success'
              });
              self.$router.push('/plus/coupon/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    /*表格数据格式化*/
    tableFormet(list) {
      let spec_list = [];
      let newList = [];
      let curItem = null;
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let obj = {
          product_sku_id: item.product_sku_id,
          assemble_stock: item.assemble_stock,
          assemble_price: item.assemble_price,
          product_attr: item.spec_name,
          assemble_product_sku_id:item.assemble_product_sku_id,
          product_price:item.product_price,
          sales_initial:item.sales_initial
        };
        if (curItem == null) {
          curItem = item;
        }
        if (curItem.product_id != item.product_id) {
          curItem.spec_list = spec_list;
          newList.push(curItem);
          curItem = item;
          spec_list = [];
        }
        spec_list.push(obj);
      }
      curItem.spec_list = spec_list;
      newList.push(curItem);
      return newList;
    },
    /*取消*/
    cancelFunc(){
      this.$router.push({
        path:'/plus/coupon/index',
      });
    },
    // 上传详情附加图
    returnBgImgFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true;
              return false
            }
          });
        });
        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        if(this.bg_type=='bg'){
          this.form.bgImage = e[0]
           this.form.bg_image = e[0].file_id
        }else{
          if(this.bg_type=='exchange_bg'){
            // exchange_bg file_path
            this.form.exchange_bg = e[0].file_path
          }else{
            this.form.shareImage = e[0]
            this.form.share_image = e[0].file_id
          }
          
        }
        
      }
      this.isBgUpload = false
    },
    bgUpload(bg_type) {
      this.bg_type = bg_type;
      this.isBgUpload = true
    },
    deleteBgImg(bg_type) {
      if(bg_type=='bg'){
        this.form.bg_image = 0
        this.form.bgImage = null
      }else{
        if(this.bg_type=='exchange_bg'){
          // exchange_bg file_path
          this.form.exchange_bg = ''
        }else{
          this.form.share_image = 0
          this.form.shareImage = null
        }
        
      }
      
    },
    /*获取富文本框内容*/
    getContent: function() {
      //return this.$refs.ue.getUEContent();
    },
    /*获取富文本内容*/
    contentChangeFunc(e) {
      this.form.content = e;
    },
  }
};
</script>

<style lang="scss" scoped>
.product-add {
  padding-bottom: 50px;
}

.tips {
  color: #ccc;
}
.img-select {
  position: relative;
  width: 110px;
  height: 110px;
  margin-right: 10px;
  i {
    display: flex;
    line-height: 110px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px dashed #dddddd;
    font-size: 30px;
    color: #409eff;
  }
}
.image-box {
  width: 110px;
  height: 110px;
  overflow: hidden;
  img {
    width: 110px;
    //height: 110px;
  }
}
.image-box:hover .delete-btn {
  display: block;
}
.default-image-box {
  position: relative;
  width: 110px;
  height: 110px;
}
.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/add.vue